// import Link from 'next/link'

import Link from '@components/common/Link/Link'

import Media from '@components/ui/Media/Media'
import { FurnitureIconFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { CSSProperties } from 'react'
import { FreeMode, Keyboard, Mousewheel, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import s from './FurnitureViewer.module.scss'

export type FurnitureViewerProps = {
  items: FurnitureIconFragment[]
  size?: number | null
  fullWidth?: boolean
}

const FurnitureViewer: React.FC<FurnitureViewerProps> = ({
  items,
  size = 80,
}) => {
  return (
    <div
      className={s.root}
      style={{ '--size': size ? `${size}px` : '80px' } as CSSProperties}
    >
      <div className={s.sliderWrapper}>
        <Swiper
          slidesPerView="auto"
          slidesPerGroup={1}
          modules={[Keyboard, Mousewheel, FreeMode, Navigation]}
          freeMode
          mousewheel={{ forceToAxis: true }}
          grabCursor
          keyboard={{
            enabled: true,
            onlyInViewport: true,
          }}
        >
          {items
            .filter((x) => !!x.media?.url)
            .map((item, index) => (
              <SwiperSlide className={s.sliderItem} key={index}>
                <Link link={item.link} className={s.sliderItem}>
                  <div
                    className={clsx(s.iconWrapper, {
                      [s.notSvg]:
                        item.media.media.__typename === 'Image' &&
                        item.media.media.umbracoExtension != '.svg',
                    })}
                  >
                    <Media
                      className={s.icon}
                      mediaClassName={s.mediaClassName}
                      mediaWithCrops={item.media}
                      disableShopTheLook
                    />
                  </div>

                  <div className={s.label}>{item.label}</div>
                </Link>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  )
}

export default FurnitureViewer
